<div>
    <button mat-icon-button mat-dialog-close><mat-icon>close</mat-icon></button>
</div>
<div>
    <img src="assets/map.png" class="map" alt="Map of the Enchanted Forest"/>
</div>